const companyColumns = [
    {
        key: 'company_name',
        label: '기업명',
        sortable: true,
        thClass: ['mb-0','text-left'],
        tdClass: ['text-left'],
    },
    {
        key: 'id',
        label: '기업 ID',
        sortable: true,
        thClass: ['mb-0','text-center'],
        thStyle: {
            width: '120px',
        },
        tdClass: ['text-center'],
    },
    {
        key: 'company_code',
        label: '기업 코드',
        sortable: true,
        thClass: ['mb-0','text-center'],
        thStyle: {
            width: '150px',
        },
        tdClass: ['text-center'],
    },
    {
        key: 'country',
        label: '국가',
        sortable: true,
        thClass: ['mb-0','text-center'],
        thStyle: {
            width: '150px',
        },
        tdClass: ['text-center'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];
const userColumns = [
    {
        key: 'index',
        label: '번호',
        sortable: true,
        thStyle: {
            width: '80px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'user_id',
        label: '유저 ID',
        sortable: true,
        thStyle: {
            width: '90px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'e_mail',
        label: '이메일(로그인 ID)',
        sortable: true,
        thClass: ['mb-0'],
    },
    {
        key: 'user_name',
        label: '사용자명',
        sortable: true,
        thClass: ['mb-0','text-left'],
        tdClass: ['text-left'],
    },
    {
        key: 'is_admin',
        label: '사용자 레벨',
        sortable: true,
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
        thStyle: {
            width: '120px'
        },
    },
    {
        key: 'update',
        label: '수정',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
];

const companyRequestColumn = [
    {
        key: 'period',
        label: '참여기간',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'project_code',
        label: '프로젝트'
    },
    {
        key: 'client',
        label: '원청사'
    },
    {
        key: 'campaign_id',
        label: '캠페인',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'industry_name',
        label: '평가산업',
        thStyle: {
            width: '120px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'status_code',
        label: '상태',
        thStyle: {
            width: '80px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'member',
        label: '참여자 관리',
        thStyle: {
            width: '140px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
    {
        key: 'status',
        label: '바로가기',
        thStyle: {
            width: '120px'
        },
        thClass: ['mb-0','text-center'],
        tdClass: ['text-center'],
    },
];

const companyRequestMemberColumn = [
    {
        key: 'project_code',
        label: '프로젝트 코드 (캠페인)',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle'
    },
    {
        key: 'user_company_name',
        label: '사용자 소속 기업 / 평가 참여 기업',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle'
    },
    {
        key: 'e_mail',
        label: '계정 및 이름',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle'
    },
    {
        key: 'role',
        label: '평가 역할',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle text-center'
    },
    {
        key: 'access_status',
        label: '참여 상태',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle text-center'
    },
    {
        key: 'managing',
        label: '권한 관리',
        thClass: 'f-90',
        tdClass: 'f-80 align-middle text-center'
    }
];

export {
    companyColumns, userColumns,companyRequestMemberColumn, companyRequestColumn
};
